import { ExchangeSettings, ExchangeAuth, Server } from "./types";
import { Enum_CalendarReminderTime } from "generated/graphql";
import i18next from "utilities/i18n";
import {
  isValidIpOrDomain,
  whenDisabled,
  boolean,
  mixedEnum,
  stringF,
  object
} from "./helpers";

export const auth = object<ExchangeAuth>({
  domain: stringF("DOMAIN")
    .max(253)
    .test(
      "validate-domain",
      i18next.t("ERROR_EXCHANGE_DOMAIN"),
      isValidIpOrDomain
    ),
  email: stringF("EMAIL_ADDRESS")
    .max(254)
    .email(),
  password: stringF("PASSWORD").max(47),
  userName: stringF("USERNAME").max(64)
});

const server = object<Server>({
  url: stringF("MS_EXCHANGE_SERVER").max(253)
});

export const exchange = object<ExchangeSettings>({
  enable: boolean("ENABLE_CALENDARING"),
  showPrivateMeeting: boolean("SHOW_PRIVATE_MEETINGS"),
  auth: auth.when("enable", whenDisabled(object())),
  server: server,
  meeting: object({
    reminderInterval: mixedEnum(
      Enum_CalendarReminderTime,
      "MEETING_REMINDER_TIME"
    ).default(Enum_CalendarReminderTime.Five),
    reminderSound: object({
      enable: boolean("MEETING_TONE_WHEN_NOT_IN_CALL")
    })
  })
});
